exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".streams-drawer-recommended-header cu-icon[name=\"instagram\"] .cu-icon {\n  height: 24px;\n  width: 24px;\n}\n.streams-drawer-recommended-header .cu-icon-sm {\n  height: 16px;\n  width: 16px;\n}\n.stream-description-wrapper {\n  height: 24px;\n}\n", ""]);

